/*
 * Saracen center carousel (infinite)
 * - Nekonečná smyčka: naklonuje sadu slidů před a za reálnou sadu; když scroll
 *   dojede do klonů, neviditelně skočí o šířku jedné sady zpět.
 * - Prostřední (nejblíž středu) slide dostane .is-center (CSS ho zvětší).
 * - Šipky posouvají o jeden slide.
 * Kontejner: [data-center-carousel], scroller: [data-cc-track], slidy: .chef-card
 */
(function () {
  if (window.__saracenCenterCarousel) return;
  window.__saracenCenterCarousel = true;

  function setup(root) {
    if (root.dataset.ccReady) return;
    var track = root.querySelector('[data-cc-track]');
    if (!track) return;

    var real = Array.prototype.slice.call(track.querySelectorAll('[data-cc-slide]'));
    if (!real.length) return;
    root.dataset.ccReady = '1';
    root.classList.add('cc-active');

    var prev = root.querySelector('[data-cc-prev]');
    var next = root.querySelector('[data-cc-next]');
    var infinite = real.length > 1;

    // --- Klonování pro nekonečnou smyčku (sada před + za) ---
    if (infinite) {
      var before = document.createDocumentFragment();
      var after = document.createDocumentFragment();
      real.forEach(function (s) {
        var a = s.cloneNode(true);
        a.classList.add('cc-clone');
        a.setAttribute('aria-hidden', 'true');
        before.appendChild(a);
        var b = s.cloneNode(true);
        b.classList.add('cc-clone');
        b.setAttribute('aria-hidden', 'true');
        after.appendChild(b);
      });
      track.insertBefore(before, track.firstChild);
      track.appendChild(after);
    }

    function all() {
      return Array.prototype.slice.call(track.querySelectorAll('[data-cc-slide]'));
    }

    var setWidth = 0;
    function measure() {
      if (!infinite) return;
      var slides = all();
      // šířka jedné sady = offset prvního reálného slidu (klony jsou před ním)
      setWidth = slides[real.length].offsetLeft - slides[0].offsetLeft;
    }

    function centerSlide(slide) {
      track.scrollLeft = slide.offsetLeft - (track.clientWidth - slide.offsetWidth) / 2;
    }

    function updateCenter() {
      var rect = track.getBoundingClientRect();
      var mid = rect.left + rect.width / 2;
      var best = null;
      var bestD = Infinity;
      var slides = all();
      slides.forEach(function (s) {
        var r = s.getBoundingClientRect();
        var d = Math.abs(r.left + r.width / 2 - mid);
        if (d < bestD) { bestD = d; best = s; }
      });
      slides.forEach(function (s) { s.classList.toggle('is-center', s === best); });
    }

    function normalize() {
      if (!infinite || !setWidth) return;
      var max = track.scrollWidth - track.clientWidth;
      if (track.scrollLeft < setWidth * 0.5) {
        track.scrollLeft += setWidth;
      } else if (track.scrollLeft > max - setWidth * 0.5) {
        track.scrollLeft -= setWidth;
      }
    }

    var raf;
    var settleTimer;
    track.addEventListener('scroll', function () {
      // vizuální zvětšení sleduj plynule
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(updateCenter);
      // nekonečný skok AŽ po dojetí scrollu (jinak by přerušil plynulý
      // scroll ze šipky a "vracelo" by se to)
      clearTimeout(settleTimer);
      settleTimer = setTimeout(function () {
        normalize();
        updateCenter();
      }, 150);
    }, { passive: true });

    function step(dir) {
      var slides = all();
      if (!slides.length) return;
      var w = slides[0].getBoundingClientRect().width + 24;
      track.scrollBy({ left: dir * w, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    function start() {
      measure();
      var slides = all();
      // vycentrovat prostřední slide reálné sady
      var idx = infinite
        ? real.length + Math.floor(real.length / 2)
        : Math.floor(slides.length / 2);
      if (slides[idx]) centerSlide(slides[idx]);
      updateCenter();
    }

    window.addEventListener('resize', function () {
      measure();
      updateCenter();
    });

    // počkat na layout obrázků (aby setWidth/centrování sedělo)
    if (document.readyState === 'complete') {
      requestAnimationFrame(start);
    } else {
      window.addEventListener('load', function () { requestAnimationFrame(start); });
      requestAnimationFrame(start); // i tak zkusit hned
    }
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-center-carousel]').forEach(setup);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
